// extracted by mini-css-extract-plugin
export default {"r_l":"_2e34ae6387 bb9f9d8b76","t":"_3ec65f084d"};